export default {
  'set_states': (state, value) => state.states = value
}
